import { $el } from 'src/scripts/utils/utils'
import { BaseComponent } from '../base-component'

const INPUT_SELECTOR = `[data-localization-input]`
const FORM_SELECTOR = 'form'

export class LocalizationSelector extends BaseComponent {
  mountComponent(): void {
    this.addListener(this, 'click', this.handleClick)
  }

  handleClick = (event: MouseEvent): void => {
    event.preventDefault()

    const target = event.target as HTMLElement
    const item = target.closest(`[data-localization-item]`) as HTMLElement

    if (item) {
      const input: HTMLInputElement = $el(INPUT_SELECTOR, this)
      const form: HTMLFormElement = $el(FORM_SELECTOR, this)

      if (!input || !form || !item.dataset.value) {
        return
      }

      input.value = item.dataset.value
      form.submit()
    }
  }
}
